import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 24px;
  margin: 0 16px;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InviteTitle = styled.h1`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme, $color }) => $color || theme.colors.white};
  text-align: center;
`;
